<template>
  <el-row v-loading.body="fetchLoding">
    <el-row
      type="flex"
      align="middle"
      style="background-color: #eee; color: #333;"
      v-if="this.isEdit"
    >
      <el-col style="padding-right: 50px; line-height: 60px; text-align: right;">
        <el-button @click="viewStatistics">{{generateCustomizeString('couponStatistics')}}</el-button>
        <el-button type="primary" @click="updateCoupon">{{generateCustomizeString('update')}}</el-button>
      </el-col>
    </el-row>
    <!-- 基本信息 -->
    <el-form
      :model="couponForm"
      :rules="rules"
      label-width="170px"
      ref="ruleForm"
      style="padding: 10px 50px 30px 50px;"
    >
      <div>
        <h4
          v-if="!this.isEdit"
          style="padding: 20px 0 10px 30px;"
        >{{generateCustomizeString('newCoupon')}}</h4>
        <h4 v-else>{{generateCustomizeString('editCoupon')}}</h4>
        <el-form-item :label="generateCustomizeString('collectCouponUrl')" v-if="this.isEdit">
          <el-tag style="font-size: 13px;">
            <a
              :href="mobileUrl + '/coupon/' + couponForm.code"
              target="_blank"
              style="text-decoration:underline;"
            >{{ mobileUrl + '/coupon/' + couponForm.code }}</a>
          </el-tag>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('pcCollectCouponUrl')" v-if="this.isEdit">
          <el-tag style="font-size: 13px;">
            <a
              :href="pcUrl + '/my/coupon?code=' + couponForm.code"
              target="_blank"
              style="text-decoration:underline;"
            >{{ pcUrl + '/my/coupon?code=' + couponForm.code }}</a>
          </el-tag>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('couponName')"
          prop="title"
          v-if="this.isEdit"
        >
          <el-input
            v-model="couponForm.title"
            :placeholder="generateCustomizeString('couponName')"
            style="width: 400px;"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponName')" prop="title" v-else>
          <el-input
            v-model="couponForm.title"
            :placeholder="generateCustomizeString('couponName')"
            style="width: 400px;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponCode')" prop="code">
          <el-input
            v-model="couponForm.code"
            :placeholder="generateCustomizeString('autoCode')"
            style="width: 300px;"
          ></el-input>
          <el-tag
            v-if="!this.isEdit && couponForm.code"
            style="margin-left: 10px; font-size: 13px;"
          >
            {{generateCustomizeString('collectCouponUrl')}}:
            <a
              :href="mobileUrl + '/coupon/' + couponForm.code"
              target="_blank"
              style="text-decoration:underline;"
            >{{ mobileUrl + '/coupon/' + couponForm.code }}</a>
          </el-tag>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponCondition')" prop="full_threshold">
          <el-input
            v-model="couponForm.full_threshold"
            :placeholder="generateCustomizeString('couponCondition')"
            style="width: 300px;"
            v-if="this.isEdit"
            disabled
          >
            <template slot="prepend">NZD $</template>
          </el-input>
          <el-input
            v-model.number="couponForm.full_threshold"
            type="number"
            :placeholder="generateCustomizeString('couponCondition')"
            style="width: 300px;"
            v-else
          >
            <template slot="prepend">NZD $</template>
          </el-input>
        </el-form-item>

        <el-form-item :label="generateCustomizeString('couponType')" prop="type">
          <el-select
            v-model="couponForm.type"
            :placeholder="generateCustomizeString('couponType')"
            style="width: 300px;"
            v-if="this.isEdit"
            disabled
          >
            <el-option
              v-for="item in couponType"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
          <el-select
            v-model="couponForm.type"
            :placeholder="generateCustomizeString('couponType')"
            style="width: 300px;"
            v-else
          >
            <el-option
              v-for="item in couponType"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('couponDeduction')"
          prop="reduction"
          v-if="couponForm.type === 0"
        >
          <el-input
            v-model="couponForm.reduction"
            type="number"
            :placeholder="generateCustomizeString('deductionCondition')"
            style="width: 300px;"
            v-if="this.isEdit"
            disabled
          >
            <template slot="prepend">NZD $</template>
          </el-input>
          <el-input
            v-model.number="couponForm.reduction"
            type="number"
            :placeholder="generateCustomizeString('deductionCondition')"
            style="width: 300px;"
            v-else
          >
            <template slot="prepend">NZD $</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('couponDiscount')"
          prop="reduction"
          v-if="couponForm.type === 1"
        >
          <el-input
            v-model="couponForm.reduction"
            :placeholder="generateCustomizeString('discountCondition')"
            type="number"
            step="0.01"
            min="0.01"
            max="0.99"
            style="width: 300px;"
            v-if="this.isEdit"
            disabled
          ></el-input>
          <el-input
            v-model.number="couponForm.reduction"
            :placeholder="generateCustomizeString('discountCondition')"
            type="number"
            step="0.01"
            min="0.01"
            max="0.99"
            style="width: 300px;"
            v-else
          ></el-input>
          <span style="color: #606266;">（{{generateCustomizeString('discountTip')}}）</span>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponEffectiveDate')" prop="effective_date">
          <el-date-picker
            v-model="datetimeRange"
            type="datetimerange"
            :range-separator="generateCustomizeString('to')"
            :start-placeholder="generateCustomizeString('start')"
            :end-placeholder="generateCustomizeString('end')"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            style="width: 460px;"
            :disabled="isEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponTotalNumber')" prop="count">
          <el-input
            v-model="couponForm.count"
            type="number"
            min="0"
            :placeholder="generateCustomizeString('unlimitedNumber')"
            style="width: 300px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('collectedCoupon')"
          prop="get_count"
          v-if="this.isEdit"
        >
          <el-tag
            style="width: 100px; text-align: center; font-size: 14px;"
          >{{ couponForm.get_count }}</el-tag>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('usedCoupon')"
          prop="used_count"
          v-if="this.isEdit"
        >
          <el-tag
            type="success"
            style="width: 100px; text-align: center; font-size: 14px;"
          >{{ couponForm.used_count }}</el-tag>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('numberPerCustomer')"
          prop="max_receive_limit"
        >
          <el-input
            v-model="couponForm.max_receive_limit"
            type="number"
            min="0"
            :placeholder="generateCustomizeString('numberPerCustomer')"
            style="width: 300px;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('couponRemark')" prop="comment">
          <el-input
            v-model="couponForm.comment"
            :placeholder="generateCustomizeString('couponRemark')"
            style="width: 600px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('isShowedInCollection')"
          prop="show_in_center"
        >
          <el-switch v-model="couponForm.show_in_center" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('status')" prop="enabled">
          <el-switch v-model="couponForm.enabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </div>

      <el-col>
        <el-form-item style="margin-left: 0px; margin-top: 20px;">
          <el-button
            v-if="isEdit"
            type="primary"
            @click="updateCoupon"
            class="btn"
          >{{generateCustomizeString('update')}}</el-button>
          <el-button
            v-else
            type="primary"
            @click="createCoupon"
            class="btn"
          >{{generateCustomizeString('create')}}</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'CouponDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL +
          this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url,
      fetchLoding: false,
      datetimeRange: [],
      couponForm: {
        title: '',
        code: '',
        full_threshold: null,
        type: null,
        reduction: null,
        begin_at: '',
        expired_at: '',
        count: '',
        get_count: '',
        used_count: '',
        max_receive_limit: '',
        comment: '',
        show_in_center: 1,
        enabled: 1
      },
      couponType: [
        {
          type: 0,
          name: this.generateCustomizeString('deduction')
        },
        {
          type: 1,
          name: this.generateCustomizeString('discount')
        }
      ],
      view: {},
      rules: {
        title: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        full_threshold: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        reduction: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        max_receive_limit: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    displayLogoUrl() {
      return (
        this.couponForm.shop_logo_url +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  },
  methods: {
    generateCustomizeString,
    fetchCoupon() {
      this.fetchLoding = true
      request({
        url: 'coupon/' + this.$route.params.couponId,
        method: 'get'
      })
        .then(res => {
          if (res.begin_at) {
            this.datetimeRange.push(dayjs(res.begin_at).toDate())
          }
          if (res.expired_at) {
            this.datetimeRange.push(dayjs(res.expired_at).toDate())
          }

          res.reduction = (res.reduction * 100) / 10000

          res.full_threshold = (res.full_threshold * 100) / 10000

          this.couponForm = res
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    viewStatistics() {
      this.$router.push({
        name: 'CouponStatistics',
        params: { couponId: this.$route.params.couponId }
      })
    },
    updateCoupon() {
      if (
        this.couponForm.type === 0 &&
        parseInt(this.couponForm.reduction) >
          parseInt(this.couponForm.full_threshold)
      ) {
        this.$message({
          message: this.generateCustomizeString('discountInputError'),
          type: 'warning'
        })
        return
      }
      if (
        this.couponForm.type === 1 &&
        parseFloat(this.couponForm.reduction > 0.99)
      ) {
        this.$message({
          message: this.generateCustomizeString('discountInputError'),
          type: 'warning'
        })
        return
      }
      if (!this.couponForm.begin_at || !this.couponForm.expired_at) {
        this.$message({
          message: this.generateCustomizeString('enterCouponValidTime'),
          type: 'warning'
        })
        return
      }
      if (!this.couponForm.max_receive_limit) {
        this.$message({
          message: this.generateCustomizeString('enterUserMaxReceive'),
          type: 'warning'
        })
        return
      }
      if (this.couponForm.code) {
        if (this.couponForm.code.length < 4) {
          this.$message({
            message: this.generateCustomizeString('couponNotLessThan4Char'),
            type: 'warning'
          })
          return
        }
      }

      this.fetchLoding = true
      request({
        url: 'coupon/' + this.$route.params.couponId,
        method: 'patch',
        data: {
          title: this.couponForm.title,
          code: this.couponForm.code,
          full_threshold: this.couponForm.full_threshold * 100,
          type: this.couponForm.type,
          reduction: this.couponForm.reduction * 100,
          begin_at: this.couponForm.begin_at,
          expired_at: this.couponForm.expired_at,
          count: this.couponForm.count,
          max_receive_limit: this.couponForm.max_receive_limit,
          comment: this.couponForm.comment,
          show_in_center: this.couponForm.show_in_center,
          enabled: this.couponForm.enabled
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delVisitedViews', this.view).then(() => {
              this.$router.push({ name: 'CouponList' })
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            message: this.generateCustomizeString('updateFailed'),
            type: 'error'
          })
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    createCoupon() {
      if (this.couponForm.type === 0) {
        if (this.couponForm.reduction > this.couponForm.full_threshold) {
          this.$message({
            message: this.generateCustomizeString('discountInputError'),
            type: 'warning'
          })
          return
        }
      } else if (this.couponForm.type === 1) {
        if (this.couponForm.reduction > 0.99) {
          this.$message({
            message: this.generateCustomizeString('discountInputError'),
            type: 'warning'
          })
          return
        }
      }
      if (!this.datetimeRange[0] || !this.datetimeRange[1]) {
        this.$message({
          message: this.generateCustomizeString('enterCouponValidTime'),
          type: 'warning'
        })
        return
      }
      if (!this.couponForm.max_receive_limit) {
        this.$message({
          message: this.generateCustomizeString('enterUserMaxReceive'),
          type: 'warning'
        })
        return
      }
      if (this.couponForm.code) {
        if (this.couponForm.code.length < 4) {
          this.$message({
            message: this.generateCustomizeString('couponNotLessThan4Char'),
            type: 'warning'
          })
          return
        }
      }

      if (this.datetimeRange && this.datetimeRange.length === 2) {
        const dates = this.datetimeRange.map(date =>
          dayjs(date)
            .utc()
            .format('YYYY-MM-DD HH:mm:ss')
        )
        this.couponForm.begin_at = dates[0]
        this.couponForm.expired_at = dates[1]
      }

      var data = {
        title: this.couponForm.title,
        code: this.couponForm.code,
        full_threshold: this.couponForm.full_threshold * 100,
        type: this.couponForm.type,
        reduction: this.couponForm.reduction * 100,
        begin_at: this.couponForm.begin_at,
        expired_at: this.couponForm.expired_at,
        count: this.couponForm.count,
        max_receive_limit: this.couponForm.max_receive_limit,
        comment: this.couponForm.comment,
        show_in_center: this.couponForm.show_in_center,
        enabled: this.couponForm.enabled
      }
      request({
        url: '/coupon/create',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delVisitedViews', this.view).then(() => {
              this.$router.push({ name: 'CouponList' })
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    }
  },
  created() {
    if (this.isEdit) {
      this.fetchCoupon()
    }
    for (let i = 0; i < this.$store.state.tagsView.visitedViews.length; i++) {
      if (
        this.$store.state.tagsView.visitedViews[i].name === 'CreateCoupon' ||
        this.$store.state.tagsView.visitedViews[i].name === 'EditCoupon'
      ) {
        this.view = this.$store.state.tagsView.visitedViews[i]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn {
  width: 150px;
  height: 50px;
  font-size: 16px;
}
</style>
>
